export default class CareerSection {
  constructor(data) {
    this.title = null;
    this.body = null;
    // Initialize data
    if (data) {
      Object.assign(this, {
        title: data.Title,
        body: data.Body
      });
    }
  }
}



// WEBPACK FOOTER //
// src/entities/career-section.js